(() => {
  const key = 'gyh3-shipping-visit';
  let offerVisit = false;
  try {
    if (new URLSearchParams(location.search).get('gyh3_offer') === '1') {
      sessionStorage.setItem(key, String(Date.now()));
      location.replace('/discount/GYH3SHIP?redirect=' + encodeURIComponent(location.pathname));
      return;
    }
    const started = Number(sessionStorage.getItem(key));
    offerVisit = !!started && Date.now() - started <= 3 * 60 * 60 * 1000;
  } catch (_) { /* Manual code entry can still be detected. */ }

  function syncOfferMessage() {
    const cart = document.querySelector('#rebuy-cart');
    if (!cart) return;
    const bar = cart.querySelector('.rebuy-cart__progress-bar-container.above');
    if (!bar) return;
    const hasBottle = !!cart.querySelector('.product-hogsworth-the-11-batch-04-750ml-single-bottle');
    const codeInCart = [...cart.querySelectorAll('.rebuy-cart__flyout-discount-tag-text')]
      .some(tag => tag.textContent.trim().toUpperCase() === 'GYH3SHIP');
    const eligible = hasBottle && (offerVisit || codeInCart);
    let note = cart.querySelector('#gyh3-shipping-note');
    if (eligible) {
      if (bar.style.display !== 'none') bar.style.display = 'none';
      if (!note) {
        note = document.createElement('div');
        note.id = 'gyh3-shipping-note';
        note.setAttribute('role', 'status');
        note.innerHTML = '<strong>FREE SHIPPING OFFER ADDED</strong><span>Shipping savings are confirmed at checkout.</span>';
        note.style.cssText = 'background:#2d2928;color:#f8f1df;padding:12px 20px;text-align:center;display:flex;flex-direction:column;gap:2px;font-size:12px;letter-spacing:.03em;';
        bar.insertAdjacentElement('afterend', note);
      }
    } else {
      if (bar.style.display === 'none') bar.style.removeProperty('display');
      if (note) note.remove();
    }
  }
  const observer = new MutationObserver(syncOfferMessage);
  observer.observe(document.body, { childList: true, subtree: true });
  syncOfferMessage();
})();